import { render, staticRenderFns } from "./CustomerInfoHistory.vue?vue&type=template&id=668f37ac"
import script from "./CustomerInfoHistory.vue?vue&type=script&lang=js"
export * from "./CustomerInfoHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports